import { render, staticRenderFns } from "./ChannelTwo.vue?vue&type=template&id=8abe4942&scoped=true"
import script from "./ChannelTwo.vue?vue&type=script&lang=js"
export * from "./ChannelTwo.vue?vue&type=script&lang=js"
import style0 from "./ChannelTwo.vue?vue&type=style&index=0&id=8abe4942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abe4942",
  null
  
)

export default component.exports